import React, { forwardRef } from 'react';

import PropTypes from 'prop-types';

import CustomHelmet from '../CustomHelmet';
import PageContext from './PageContext';

const Page = forwardRef(({ title, description, messages, values, children, ...rest }, ref) => (
  <PageContext.Provider value={{ title }}>
    <div ref={ref} {...rest}>
      <CustomHelmet title={title} description={description} messages={messages} values={values} />
      {children}
    </div>
  </PageContext.Provider>
));

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  messages: PropTypes.object,
  values: PropTypes.object,
};

export default Page;
